import React, { Component } from "react";
import img from "../img/Final.svg";
import { MdArrowBackIos } from 'react-icons/md'
import {
    Navbar,
    Container,
} from "reactstrap";
import "../css/header.css";

export default class HeaderLink extends Component {
    render() {
        return (
            <div>
                <Navbar color="light" className="main-screen" expand="md" dark fixed="top">
                    <Container>
                        <img src={img} height="55" width="70" className="float-left" />
                        <div className="float-right row no-gutters" style={{ color: '#fff', cursor: 'pointer' }} onClick={this.props.gotoMomKidCare}>
                            <div className="col-6">
                                <MdArrowBackIos size='25' className="float-right" />
                            </div>
                            <div className="col-6 " style={{ lineHeight: '1', fontSize: '12px' }}>
                                Back To Momkidcare
                            </div>
                        </div>
                    </Container>
                </Navbar>
            </div>
        );
    }
}
